import React from 'react';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './Step3Industry.module.css';

const Step3Industry = ({ nextStep, prevStep, initialValues, className, rootClassName }) => {
  const classes = classNames(rootClassName || css.root, className);

  const validate = values => {
    const errors = {};
    if (!values.primaryIndustry) errors.primaryIndustry = 'Please select a primary industry';
    return errors;
  };

  const onSubmit = values => {
    nextStep(values);
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={classNames(classes, css.form)}>

          <div className={css.header}>
            <span className={css.step}>Step 3 of 5</span>
            <h2 className={css.title}>Industry Details</h2>
            <p className={css.description}>Please select your industry and describe what you produce.</p>
          </div>

          <hr className={css.divider} />

          <section className={css.section}>

            <div className={css.field}>
              <label className={css.label}>
                Primary Industry <span className={css.required}>*</span>
              </label>
              <Field name="primaryIndustry">
                {({ input, meta }) => (
                  <>
                    <select
                      {...input}
                      className={classNames(css.select, { [css.inputError]: meta.touched && meta.error })}
                    >
                      <option value="">Select Primary Industry</option>
                      <option>Electronics</option>
                      <option>Furniture</option>
                      <option>Textile</option>
                      <option>Machinery</option>
                      <option>Automotive</option>
                      <option>Chemical</option>
                      <option>Food &amp; Beverage</option>
                      <option>Toys &amp; Games</option>
                      <option>Plastic &amp; Rubber</option>
                      <option>Metal &amp; Steel</option>
                    </select>
                    {meta.touched && meta.error && <span className={css.error}>{meta.error}</span>}
                  </>
                )}
              </Field>
            </div>

            <div className={css.field}>
              <label className={css.label}>Secondary Industry (Optional)</label>
              <Field name="secondaryIndustry">
                {({ input }) => (
                  <select {...input} className={css.select}>
                    <option value="">Select Secondary Industry</option>
                    <option>Packaging</option>
                    <option>Plastic</option>
                    <option>Metal</option>
                    <option>Wood</option>
                    <option>Logistics</option>
                  </select>
                )}
              </Field>
            </div>

            <div className={css.field}>
              <label className={css.label}>Products / Services You Provide (Optional)</label>
              <Field name="products">
                {({ input }) => (
                  <textarea
                    {...input}
                    rows={4}
                    className={css.textarea}
                    placeholder="Describe your main products or services (e.g. LED lighting, wooden furniture…)"
                  />
                )}
              </Field>
            </div>

            <div className={css.field}>
              <label className={css.label}>Annual Production Capacity (Optional)</label>
              <Field name="capacity">
                {({ input }) => (
                  <select {...input} className={css.select}>
                    <option value="">Select Production Capacity</option>
                    <option>Less than 1,000 Units / Month</option>
                    <option>1,000 – 10,000 Units / Month</option>
                    <option>10,000 – 50,000 Units / Month</option>
                    <option>50,000 – 100,000 Units / Month</option>
                    <option>100,000+ Units / Month</option>
                  </select>
                )}
              </Field>
            </div>

          </section>

          <div className={css.buttonContainer}>
            <button type="button" onClick={prevStep} className={css.previous}>
              ← Previous
            </button>
            <button type="submit" className={css.button}>
              Next : Agreements →
            </button>
          </div>

        </form>
      )}
    />
  );
};

Step3Industry.defaultProps = {
  className: null,
  rootClassName: null,
  initialValues: {},
};

Step3Industry.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

export default Step3Industry;
